import {
    Badge,
    Box,
    Button,
    Group,
    Modal,
    Paper,
    Select,
    SimpleGrid,
    Stack,
    Table,
    Tabs,
    Text,
    TextInput,
    Textarea,
} from '@mantine/core';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { SearchableSelect } from '../../common';
import { faSpinnerThird } from '@fortawesome/pro-solid-svg-icons';
import { hasRole } from '../../../utils/roles';
import { useAuthStore } from '../../../store';
import { useForm } from '@mantine/form';

const CallTranscriptModal = ({ transcript, opened, close }) => {
    const rows = transcript?.segments?.map((segment, i) => (
        <Table.Tr key={i}>
            <Table.Td>{segment.start}s</Table.Td>
            <Table.Td>{segment.end}s</Table.Td>
            <Table.Td>{segment.text}</Table.Td>
            <Table.Td>{segment.complete.toString()}</Table.Td>
        </Table.Tr>
    ));

    return (
        <Modal.Root
            opened={opened}
            onClose={close}
            size={'xl'}>
            <Modal.Overlay />
            <Modal.Content>
                <Modal.Header>
                    <Modal.Title>Call Transcript</Modal.Title>
                    <Modal.CloseButton />
                </Modal.Header>
                <Modal.Body>
                    <Table>
                        <Table.Thead>
                            <Table.Tr>
                                <Table.Th>Start</Table.Th>
                                <Table.Th>End</Table.Th>
                                <Table.Th>Text</Table.Th>
                                <Table.Th>Complete</Table.Th>
                            </Table.Tr>
                        </Table.Thead>
                        <Table.Tbody>{rows}</Table.Tbody>
                    </Table>
                </Modal.Body>
            </Modal.Content>
        </Modal.Root>
    );
};
export default CallTranscriptModal;
